var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnership-welcome-screen"
  }, [_c('div', {
    staticClass: "partnership-welcome-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('bring.friends')))]), _c('h2', [_vm._v(_vm._s(_vm.$t('share.invitation.link')))]), _vm._t("default")], 2), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnership-welcome-animation"
  }, [_c('div', {
    staticClass: "background-stars-left animate__animated animate__fadeInDown"
  }), _c('div', {
    staticClass: "background-stars-right animate__animated animate__fadeInDown"
  }), _c('div', {
    staticClass: "background-workspace animate__animated animate__fadeIn"
  }), _c('div', {
    staticClass: "background-people-left animate__animated animate__fadeInRight"
  }), _c('div', {
    staticClass: "background-people-right animate__animated animate__fadeInLeft"
  })]);
}]

export { render, staticRenderFns }